import React from 'react'
import ColorPickerV2 from 'src/components/common/ColorPickerV2'
import RichTextEditor from 'src/components/common/form-elements/RichTextEditor'
import { useCartContext } from 'src/lib/contexts/CartContext'

export const BottomBannerControl = () => {
  const {
    getters: { cartBottomBannerUIConfigData },
    actions: { setCartBottomBannerConfig }
  } = useCartContext()

  return (
    <div className='space-y-5'>
      <div className='grid w-full gap-2 grid-cols-2'>
        <ColorPickerV2
          label='Background'
          color={cartBottomBannerUIConfigData.color}
          onChange={color =>
            setCartBottomBannerConfig({
              ...cartBottomBannerUIConfigData,
              color: color,
              textColor: cartBottomBannerUIConfigData.textColor,
              text: cartBottomBannerUIConfigData.text
            })
          }
        />
        <ColorPickerV2
          label='Text'
          color={cartBottomBannerUIConfigData.textColor}
          onChange={color =>
            setCartBottomBannerConfig({
              ...cartBottomBannerUIConfigData,
              color: cartBottomBannerUIConfigData.color,
              textColor: color,
              text: cartBottomBannerUIConfigData.text
            })
          }
        />
      </div>
      <div>
        <RichTextEditor
          charLimit={60}
          value={cartBottomBannerUIConfigData.text}
          handleTextChange={(content: string) => {
            setCartBottomBannerConfig({ ...cartBottomBannerUIConfigData, text: content })
          }}
          label='Banner Message'
        />
      </div>
    </div>
  )
}
